import { useQuery } from '@tanstack/react-query';

import {
  getAllClaimsUsers,
  getAllPermissions,
  getClaimUser,
  getClaimsReviewers,
  getCurrentUser,
  getMlpUser,
  getMlpUsers,
} from 'api';

import useZygoatEnvVariables from 'hooks/query-hooks/useZygoatEnvVariables';

import { withReturn } from 'zg_utils/tokens';

export const getCurrentUserQueryKey = ['get-current-user'];
export const getAllReviewersQueryKey = ['get-all-reviewers'];
export const getClaimUserQueryKey = ['get-claim-user'];
export const getAllClaimsUsersQueryKey = ['get-all-claims-users'];
export const getMlpUserQueryKey = ['get-mlp-user'];
export const getMlpUsersQueryKey = ['get-mlp-users'];
export const getPermissionsQueryKey = ['get-permissions'];

export const useCurrentUserQuery = (overrides = {}) =>
  useQuery({
    queryKey: getCurrentUserQueryKey,
    queryFn: getCurrentUser,
    staleTime: Infinity,
    ...overrides,
  });

export const useCurrentUserUtils = () => {
  const { LOGOUT_URL } = useZygoatEnvVariables();

  const logoutUser = () => {
    window.location = withReturn(LOGOUT_URL, false);
  };

  return {
    logoutUser,
  };
};

export const useAllReviewersQuery = (payload = {}, overrides = {}) =>
  useQuery({
    queryKey: getAllReviewersQueryKey.concat(payload),
    queryFn: () => getClaimsReviewers(payload),
    ...overrides,
  });

export const useClaimUserQuery = (userId, payload = {}, overrides = {}) =>
  useQuery({
    queryKey: getClaimUserQueryKey.concat(userId, payload),
    queryFn: () => getClaimUser(userId, payload),
    enabled: !!userId,
    ...overrides,
  });

export const useAllClaimsUsersQuery = (payload = {}, overrides = {}) =>
  useQuery({
    queryKey: getAllClaimsUsersQueryKey.concat(payload),
    queryFn: () => getAllClaimsUsers(payload),
    ...overrides,
  });

export const usePermissionsQuery = (payload = {}, overrides = {}) =>
  useQuery({
    queryKey: getPermissionsQueryKey.concat(payload),
    queryFn: () => getAllPermissions(payload),
    ...overrides,
  });

export const useMlpUsersQuery = (payload = {}, overrides = {}) =>
  useQuery({
    queryKey: getMlpUsersQueryKey.concat(payload),
    queryFn: () => getMlpUsers(payload),
    ...overrides,
  });

export const useMlpUserQuery = (userId, overrides = {}) =>
  useQuery({
    queryKey: getMlpUserQueryKey.concat(userId),
    queryFn: () => getMlpUser(userId),
    enabled: !!userId,
    ...overrides,
  });
